<template>
  <div class="user-manage-constructor main-body">
    <div class="button-search-body">
      <div class="search-body">
        <div class="button-body">
          <ButtonList 
            :list="buttonList"
            :target="buttonTarget"
          />
        </div>
      </div>
    </div>
    <div class="table-body">
      <TableCom
        :tableList="tableList"
        :tableProps="tableProps"
      ></TableCom>
    </div>
    <div
      class="page-body"
    >
      <Pagination 
        @pageChange="pageChange"
        :total="total"
        v-model:page="listQuery.page"
        v-model:limit="listQuery.length"
      />
    </div>
    <AddRegion
      v-if="addRegionFlag"
      :target="addRegionTarget"
      :title="title"
      @close="regionFlagClose"
      @refresh="selectList" />
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'
import TableCom from '@/components/TableCom'
import Pagination from '@/components/Pagination'
import ButtonList from '@/components/ButtonList'
import {
  ElLoading, ElMessageBox, ElImageViewer,
} from 'element-plus'
import { queryCustomRegionList,deleteCustomRegion } from '@/api/Region'

import AddRegion from '@/views/RegionManage/component/addregion'
// props
const props = defineProps({
  
})
// emit
const emit = defineEmits([
  
])

const addRegionFlag = ref(false)
const addRegionTarget = ref(undefined)
const title = ref('')
const addFun = (target, button, loadFn) => {
  addRegionFlag.value = true
  title.value = '新增绘制区域'
  addRegionTarget.value = {
    ...target,
  }
  loadFn()
}
const regionFlagClose = () => {
  addRegionTarget.value = ''
  addRegionFlag.value = false
}

const searchFun = (target, button, loadFn) => {
  selectList()
  loadFn()
}
const editRegion = (target, button, loadFn) => {
  addRegionFlag.value = true
  title.value = '编辑绘制区域'
  addRegionTarget.value = {
    ...target,
  }
  loadFn()
}
const deleteRegion = async(target, button, loadFn) => {
  ElMessageBox.confirm(
    '是否删除该区域？',
    '确认删除',
    {
      confirmButtonText: '删除并关闭',
      cancelButtonText: '取消删除',
      type: 'warning'
    }
  ).then(()=>{
    deleteCustomRegion(target.id).then(res=>{
      if(res.data.code == 1004){
        message('删除成功', 1)
        selectList()
      }
      loadFn && loadFn()
    })
  }).catch((err) => {
    loadFn && loadFn()
    console.log(err)
  })
}

// 需要序号可添加
const tableNumber = (number)=>{
  return (listQuery.page-1) * listQuery.length + number;
}
const tableProps = ref([
  { label: '序号', fun: tableNumber, fixed: true, },
  { label: 'ID', prop: 'id', },
  { label: '区域名称', prop: 'polygonName', },
  { label: '区域', prop: 'geom',  icon: "copy" },
  // { label: '目的', prop: 'purpose', },
  { label: '描述', prop: 'desc' },
  { label: '标签', prop: 'tagList', 
    fun: (target)=>{
      return (target['tagList'] || []).join()
    }
  },
  { label: '用户', prop: 'userNameList', 
    fun: (target)=>{
      return (target['userNameList'] || []).join()
    }
  },
  { label: '操作', 
    buttonList: [
      { name: '修改', icon: 'el-Edit', fun: editRegion, type: 'warning' },
      { name: '删除', icon: 'el-Delete', fun: deleteRegion, type: 'danger' },
    ]
  }
])


const buttonTarget = ref({});
const buttonList = ref([
  // { name: '查询', icon: 'el-Search', type: 'primary', fun: searchFun },
  { name: '新增绘制区域', icon: 'el-Plus', type: 'primary', fun: addFun },
])

const tableList = ref([])
let total = ref(0),
    listQuery = reactive({
      page: 1,
      length: 20
    })
// 分页器change
const pageChange = ()=>{
  selectList()
}

const selectList = ()=>{
  // console.log(listQuery);
  let load = ElLoading.service({
    lock: true,
    target: '.main-body',
    background: 'var(--loadBackColor)'
  })

  queryCustomRegionList(listQuery).then(res=>{
    if(res.data.code == 1004){
      tableList.value = res.data.dataList;
      total.value = res.data.totalCount;
    }
    load.close()
  }).catch(err=>{
    load.close()
    console.log(err)
  })
}
// 组件挂载前
onBeforeMount(()=>{

})
// 组件挂载后
onMounted(()=>{
  selectList()
})
// 组件更新后
onUpdated(()=>{

})
// 组件销毁后
onUnmounted(()=>{

})

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.user-manage-constructor {
  padding: 10px;
  --h3Height: 30px;
  
}
</style> 